/**
 * Learning Center API: the learner's records reads that WP-40's
 * api/completions.ts does not carry (plan docs/plans/lms-plan.md 7.4, 7.5,
 * R18, R24, Appendix A "Sign-offs"; WP-34's routes, WP-41's client).
 *
 *   GET /me/signoff-requests  -> { items, page } newest first, each with the
 *                                course, the named observer (null: any admin)
 *                                and the latest observation (7.4)
 *
 * The transcript (GET /me/completions), the status map, the certificate URL,
 * the certificate retry and the sign-off request post are WP-40's
 * (api/completions.ts: listMyCompletions, getMyStatus, getCertificateUrl,
 * retryCertificate, requestSignoff; plan 18.22) and are imported from there.
 */
import api from '../../services/api';
import type { LmsList } from './client';

/** The latest observation on a request (WP-34 signoffSummary). */
export interface SignoffObservation {
  id: string;
  outcome: 'competent' | 'not_yet';
  observed_at: string;
  notes: string | null;
  observer_id: string;
}

/** One GET /me/signoff-requests item (5.5 lms_signoff_requests plus WP-34's joins). */
export interface MySignoffRequest {
  id: string;
  user_id: string;
  course_id: string;
  observer_id: string | null;
  status: 'open' | 'done' | 'cancelled';
  requested_at: string;
  signoff_id: string | null;
  course: { id: string; title: string; slug: string } | null;
  observer: { id: string; full_name: string | null; email: string | null } | null;
  last_signoff: SignoffObservation | null;
}

/** GET /api/lms/me/signoff-requests */
export async function listMySignoffRequests(
  options: { limit?: number; offset?: number } = {}
): Promise<LmsList<MySignoffRequest>> {
  const params: Record<string, number> = {};
  if (options.limit !== undefined) params.limit = options.limit;
  if (options.offset !== undefined) params.offset = options.offset;
  const response = await api.get<LmsList<MySignoffRequest>>('/api/lms/me/signoff-requests', { params });
  return response.data;
}
